module.exports = __webpack_public_path__ + "static/media/quickstart-step-5.c572ae78.jpg";